module.exports = __webpack_public_path__ + "img/btn-pencil.936be7b9.svg";